const historialPagoCotizacionState = {
    detalleHistorial: [],
    detallePago: [],
    cargandoTabla: false,
    exportandoExcel: false,
    redirect: false,
}

export default historialPagoCotizacionState;
